import * as React from 'react';
import icon1 from '../../../assets/img/icon-1.png';
import icon2 from '../../../assets/img/icon-2.png';
import icon3 from '../../../assets/img/icon-3.png';

import jsonData from './json/dataBTwo';

export interface IBody {}

export default function BodyTwo(props: IBody) {
  const icons = [icon1, icon2, icon3];

  return (
    <div className=' pt-10 my-4 h-full grey'>
      <div className='mt-10 text-center  text-3xl font-medium'>
        OUR ADVANTAGES
      </div>
      <div className='mt-10     grid grid-cols-1 lg:grid-cols-3      justify-center   w-full '>
        {icons.map((icon, index) => {
          return (
            <React.Fragment key={index}>
              <div className=' flex-col flex mx-4 justify-items-center '>
                <div className='flex justify-center'>
                  <img src={icon} alt='' className='icons  ' />
                </div>
                <div className=' text-center  py-3 text-2xl '>
                  {jsonData[index].title}
                </div>
                <div className=' text-center  py-3 text-2xl  '>
                  {jsonData[index].body}
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
}
